import { __rest } from "tslib";
import * as React from 'react';
import { useTheme } from '../../theme';
import Slider from 'react-slick';
import { CdnIcon } from '@shared/ui';
import cn from 'classnames';
const SlickSlider = React.forwardRef((_a, ref) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    const theme = useTheme('SlickSlider').SlickSlider;
    return (React.createElement(Slider, Object.assign({ ref: ref, className: cn(theme.slider, className), prevArrow: React.createElement("button", { type: "button" },
            React.createElement(CdnIcon, { icon: "Arrow/Chevron_left" })), nextArrow: React.createElement("button", { type: "button" },
            React.createElement(CdnIcon, { icon: "Arrow/Chevron_right" })) }, props), children));
});
export default SlickSlider;
